/** The signed-in person's Achievements page. */
export const myAchievementsPath = '/credentials/my-achievements'

/** A person's Achievements page, as User Details links to it. */
export const personAchievementsRoute = '/credentials/user-achievements/:userId'

export function personAchievementsPath(userId: string): string {
  return `/credentials/user-achievements/${encodeURIComponent(userId)}`
}

/** The API's own achievements of the caller. */
export const myAchievementsApi = '/credentials/v1/me/achievements'

/** The API's achievements of a person, for whoever may see them. */
export function personAchievementsApi(userId: string): string {
  return `/credentials/v1/user-profiles/${encodeURIComponent(userId)}/achievements`
}

/** The caller's rewards, for the Student Dashboard's card. */
export const myRewardsApi = '/credentials/v1/me/rewards'

/** Whether the header shows the caller the trophy link. */
export const myTrophyApi = '/credentials/v1/me/trophy'

/** Reading another person's achievements and skill scores. */
export const readEarnedCredentialsPermission = 'credentials.earned-credentials.read'
